import { createSlice } from "@reduxjs/toolkit";
import { forgotPasswordAPI } from "../../api/auth";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const forgotPasswordSlice = createSlice({
  name: "forgotPassword",
  initialState: data,
  reducers: {
   forgotPasswordSlice(state) {
      state.isLoading = true;
    },
   forgotPasswordSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    forgotPasswordSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   forgotPasswordSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const forgotPasswordHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(forgotPasswordAction.forgotPasswordSlice());
    const response: any = await forgotPasswordAPI(data);
    
    dispatch(forgotPasswordAction.forgotPasswordSliceSuccess(response));
  } catch (e: any) {
    dispatch(forgotPasswordAction.forgotPasswordSliceFailure(e?.response?.data));
  }
};
export default forgotPasswordSlice.reducer;
export const forgotPasswordAction = forgotPasswordSlice.actions;
